module.exports = __webpack_public_path__ + "static/media/wiz_sailboat_selected_ic.b8acd6cc.svg";